<div class="row d-flex flex-wrap">
    <div class="col-lg">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Task Summary</p>
                        <h4 class="my-1">{{ResourceCard?.taskSummary}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-success text-success ms-auto"><i class='bx bxs-wallet'></i></div>
                </div>
                <div id="chart1"></div>
            </div>
        </div>
    </div>
    <div class="col-lg">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Milestone Hours</p>
                        <h4 class="my-1">{{ResourceCard?.milestoneHours}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-warning text-warning ms-auto"><i class='bx bxs-group'></i></div>
                </div>
                <div id="chart2"></div>
            </div>
        </div>
    </div>
    <div class="col-lg">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Performance Tag</p>
                        <h4 class="my-1">{{ResourceCard?.performanceTag}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-danger text-danger ms-auto"><i class='bx bxs-binoculars'></i></div>
                </div>
                <div id="chart3"></div>
            </div>
        </div>
    </div>
    <div class="col-lg">
        <div class="card radius-10">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <p class="mb-0 text-secondary">Task Overdue</p>
                        <h4 class="my-1">{{ResourceCard?.taskOverDue}}</h4>
                    </div>
                    <div class="widgets-icons bg-light-success text-success ms-auto"><i class='bx bxs-wallet'></i></div>
                </div>
                <div id="chart4"></div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12 col-xl-6 d-flex">
        <div class="card radius-10 w-100">
            <div class="card-body">
                <div class="d-flex align-items-center">
                    <div>
                        <h5 class="mb-0">Resources</h5>
                    </div>
                </div>
            </div>
            <div class="customers-list p-3 mb-3">
                <div class="customers-list-item d-flex align-items-center border-bottom p-2 cursor-pointer"
                    *ngFor="let resource of resource">
                    <div class="d-flex align-items-center w-100">
                        <img [src]="resource.employeeAvatar||'assets/images/avatar.png'" class="rounded-circle me-2" width="46"
                            height="46" alt="" />
                        <h6 class="mb-0 font-1" style="width:306px">{{ resource.employeeName }}</h6>
                        <h6 class="mb-0 font-14" style="width:235px">{{ resource.teamRoleName }}</h6>
                            <h6 class="mb-0 font-14 me-3" style="width:200px" >{{ resource.addedOn | date:'dd-MM-yyyy'}}</h6>
                    </div>
                </div>
            </div>
            <div class=" mt-3 mb-3">
                <a href="#" class="resource" routerLink="/project-pilot/teams">
                    View More <i class='bx bx-chevron-right ms-1'></i>
                </a>
            </div>
        </div>
    </div>
</div>